module.exports = __webpack_public_path__ + "img/turismerekreasjon_smvf.28435582.jpg";